import cx from 'classnames';

import { VerifiedIcon } from '@motorway/mw-highway-code';

import { DAMAGE } from './ReportCardStatus.helpers';

import styles from './ReportCardStatus.module.scss';

export const ReportCardPerfect = () => {
  return (
    <h4 className={cx(styles.component, styles.perfect)}>
      <span>{DAMAGE.NO_ISSUES}</span>
      <VerifiedIcon />
    </h4>
  );
};
